import { Component, Fragment, h, Prop } from '@stencil/core';
import { Article, DetailsComponents, Picker } from '../../utils/types';
import { Cart, CartItem } from '../../../../redux/types';
import { CartStatus } from '../../../../types/types';
import { t } from '../../../../redux/utils';
import { ButtonAppearance, ButtonSize } from '../../../atoms/rentware-button/types';

@Component({
  tag: 'rtr-article-details-in-cart',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrArticleDetailsInCart {
  @Prop() article: Article;
  @Prop() picker: Picker;
  @Prop() detailsComponent: DetailsComponents;
  @Prop() cart: Cart;

  get wrapperClass() {
    if (this.detailsComponent.inCartOpened) {
      return 'ADICWrapper ADICWrapperOpened';
    }

    return 'ADICWrapper';
  }

  get cartItem(): CartItem {
    return this.article.itemInCart;
  }

  get buttonAppearance(): ButtonAppearance {
    return {
      fullWidth: true,
      size: ButtonSize.XL,
    };
  }

  get buttonText() {
    return t('cart.checkoutNow');
  }

  render() {
    if (!this.cartItem || this.detailsComponent.cartStatus !== CartStatus.Active) {
      return null;
    }

    return (
      <Fragment>
        <div class={this.wrapperClass}>
          <div class="ADICContainer">
            <rtr-cart-reservation-header onCloseButton={this.detailsComponent.onCloseButtonClick} useArrowButton={true} />

            <rtr-cart-reservation-content
              cartItem={this.article.itemInCart}
              connectedArticles={this.article.connectedArticles}
              images={this.article.images}
              onShowFullGallery={this.detailsComponent.onShowFullGallery}
              totalPriceCalculation={this.cart.totalPriceCalculation}
            />

            <rtr-cart-reservation-summary onOpenCheckout={this.detailsComponent.onCheckoutButtonClick} pickerDate={this.picker} />
          </div>
        </div>

        {this.detailsComponent.inCartOpened && <div class="ADICModal" onClick={this.detailsComponent.onCloseButtonClick} />}
      </Fragment>
    );
  }
}
